<!-- Module Selector Component -->
<div class="module-selector-container">
  <div class="header">
    <h1>AI-Powered Open Educational Resource Suite</h1>
    <p>Select a module to enhance and transform educational materials</p>
  </div>
  
  <div class="modules-grid">
    <div class="module-card" [@fadeInUp]>
      <div class="module-icon">
        <i class="material-icons">text_fields</i>
      </div>
      <h2>OER Text Assistant</h2>
      <p>Generate, analyze, and refine educational texts using AI</p>
      <div class="module-footer">
        <button mat-raised-button color="primary" (click)="openTextDialog()">Enter Text Module</button>
      </div>
    </div>
    <div class="module-card" [@fadeInUp]>
      <div class="module-icon">
        <i class="material-icons">image</i>
      </div>
      <h2>OER convOERter</h2>
      <p>Create visual educational resources tailored to your content</p>
      <div class="module-footer">
        <button mat-raised-button color="primary" (click)="navigateToModule('image')">Enter Image Module</button>
      </div>
    </div>
    <!-- <div class="module-card" [@fadeInUp]>
      <div class="module-icon">
        <i class="material-icons">videocam</i>
      </div>
      <h2>OER Video Generator</h2>
      <p>Generate educational videos to enhance learning experiences</p>
      <div class="module-footer">
        <button mat-raised-button color="primary" (click)="openVideoDialog()">Enter Video Module</button>
      </div>
    </div> -->
  </div>
</div>
